export interface Rect {
  left: number;
  top: number;
  width: number;
  height: number;
}

interface TransformedImageRectOptions {
  stageRect: Rect;
  imageWidth: number;
  imageHeight: number;
  scale: number;
  positionX: number;
  positionY: number;
}

export const getContainedRect = (
  containerWidth: number,
  containerHeight: number,
  imageWidth: number,
  imageHeight: number
): Rect => {
  const safeContainerWidth = Math.max(containerWidth, 1);
  const safeContainerHeight = Math.max(containerHeight, 1);
  const safeImageWidth = Math.max(imageWidth, 1);
  const safeImageHeight = Math.max(imageHeight, 1);

  const containerRatio = safeContainerWidth / safeContainerHeight;
  const imageRatio = safeImageWidth / safeImageHeight;

  if (containerRatio > imageRatio) {
    const height = safeContainerHeight;
    const width = height * imageRatio;

    return {
      left: (safeContainerWidth - width) / 2,
      top: 0,
      width,
      height,
    };
  }

  const width = safeContainerWidth;
  const height = width / imageRatio;

  return {
    left: 0,
    top: (safeContainerHeight - height) / 2,
    width,
    height,
  };
};

export const getTransformedImageRect = ({
  stageRect,
  imageWidth,
  imageHeight,
  scale,
  positionX,
  positionY,
}: TransformedImageRectOptions): Rect => {
  const containedRect = getContainedRect(
    stageRect.width,
    stageRect.height,
    imageWidth,
    imageHeight
  );

  return {
    left: stageRect.left + positionX + containedRect.left * scale,
    top: stageRect.top + positionY + containedRect.top * scale,
    width: containedRect.width * scale,
    height: containedRect.height * scale,
  };
};

export const isPointInsideRect = (x: number, y: number, rect: Rect): boolean =>
  x >= rect.left &&
  x <= rect.left + rect.width &&
  y >= rect.top &&
  y <= rect.top + rect.height;
